// Rueda 3D de tarjetas de módulos — usada tanto en el header oscuro de
// escritorio (eje X, vertical) como en el header móvil (eje Y, horizontal).
export function Carousel3D({
  modules,
  axis = "x",
  cardWidth,
  cardHeight,
  radius,
  duration,
  tilt = -8,
  maskAxis = "vertical",
}) {
  const step = 360 / modules.length;

  return (
    <div className={`carousel3d carousel3d--mask-${maskAxis === "vertical" ? "v" : "h"}`}>
      <div
        className="carousel3d__stage"
        style={{ transform: axis === "x" ? `rotateY(${tilt}deg)` : `rotateX(${tilt}deg)` }}
      >
        <div
          className={`carousel3d__wheel carousel3d__wheel--${axis}`}
          style={{ width: cardWidth, height: cardHeight, animationDuration: `${duration}s` }}
        >
          {modules.map((module, i) => (
            <div
              key={`${module.title}-${i}`}
              className="carousel3d__card"
              style={{
                transform:
                  axis === "x"
                    ? `rotateX(${i * step}deg) translateZ(${radius}px)`
                    : `rotateY(${i * step}deg) translateZ(${radius}px)`,
              }}
            >
              <span className="carousel3d__card-cat" style={{ color: module.accent }}>
                {module.category}
              </span>
              <span className="carousel3d__card-title">{module.title}</span>
              <span className="carousel3d__card-sub">{module.subtitle}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
